var React = require('react');

function IconDASearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M789 833.3c-71.5 37.3-159.7 9.5-196.9-62-37.3-71.5-9.5-159.7 62-196.9 71.5-37.2 159.7-9.5 196.9 62 22 42.3 22 92.7 0 134.9l105.2 105.2c1.6 1.6 1.6 4.1 0 5.7l-56.3 56.3c-1.6 1.6-4.1 1.6-5.7 0L789 833.3zm-5.5-67.5c34.2-34.2 34.2-89.7 0-123.9s-89.7-34.2-123.9 0-34.2 89.7 0 123.9 89.6 34.2 123.9 0c-.1 0-.1 0 0 0zM860 533.5V369.6c0-2.2-1.8-4-4-4h-92c-2.2 0-4 1.8-4 4v125.6c35.9 4.5 70.2 17.6 100 38.3zM623.3 521.4V177.6c0-2.2-1.8-4-4-4h-92c-2.2 0-4 1.8-4 4v456.6c19.4-47.9 54.7-87.8 100-112.8zM523.3 802.2v11.4H386.6V306.1c0-2.2-1.8-4-4-4h-92c-2.2 0-4 1.8-4 4v507.5h-95.8v-640h64l-93.1-90.9c-1.6-1.5-4-1.5-5.6 0L63 173.6h63.8v703.9h446.4c-21.6-21.5-38.6-47.1-49.9-75.3z"}));
}

IconDASearch.displayName = "IconDASearch";

IconDASearch.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconDASearch;

IconDASearch.default = IconDASearch;
